<template>
  <CoreDialog
    v-model="isVisibleDialog"
    data-qa="appointment-error-modal"
    size="sm"
    :persistent="errorData.isPersistent"
    :title="$t(errorData.title, { ...options, daily_limit: dailyLimit })"
  >
    <div class="text-body-2 text-secondary--text">
      {{ $t(errorData.subtitle, options) }}
    </div>
    <template #actions>
      <v-btn
        v-if="currentActions.buttonFirst"
        data-qa="modal-actions-btn-close"
        text
        color="black"
        v-on="currentActions.buttonFirst.on"
        @click="handleClickButtonFirst"
      >
        {{ $t(currentActions.buttonFirst.text, options) }}
      </v-btn>
      <v-btn
        v-if="currentActions.buttonSecond"
        data-qa="modal-actions-btn-confirm"
        text
        color="primary"
        v-on="currentActions.buttonSecond.on"
        @click="handleClickButtonSecond"
      >
        {{ $t(currentActions.buttonSecond.text, options) }}
      </v-btn>
    </template>
  </CoreDialog>
</template>

<script>
import { mapState } from 'pinia'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import { AppointmentPageErrorData } from 'www/vue_components/common/AppointmentPage/mixins'
import { useGlobalDataStore } from 'www/vue_components/common/AppointmentPage/stores'

export default {
  name: 'AppointmentErrorDialog',
  components: { CoreDialog },
  mixins: [
    AppointmentPageErrorData,
  ],
  props: {
    dailyLimit: {
      type: Number,
      default: 0,
    },
  },
  data: vm => ({
    options: { ns: vm.$i18next.language },
  }),
  computed: {
    ...mapState(useGlobalDataStore, [
      'errorData',
    ]),
  },
}
</script>
